var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "扫码绑定微信公众号",
        closable: false,
        keyboard: false,
        maskClosable: false,
        destroyOnClose: true,
        wrapClassName: "bind-weChat-email-modal",
        width: "415px"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "tips-text" }, [
          _vm._v("请扫描关注我们的微信公众号，以便第一时间获得商标监控通知。")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "qr-code" }, [
          _vm.loadding
            ? _c("span", [_vm._v("加载中...")])
            : _vm.qrCode
            ? _c("img", { attrs: { src: _vm.qrCode } })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [_vm._v("关闭")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e09c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e09c06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myBrand/trademarkMonitor/component/BindWxQrcode.vue
// module id = null
// module chunks = 